<template>
    <div class="phone-box">  
        <div class="message">
            <div class="message-item" v-show="list.length>0" v-for="item in list" :key="item.uuid" @click="goDetail(item)">
                <div class="message-image-box">
                    <img :src="imageUrl+item.petUrl" class="message-image"/>
                </div>
                <div class="message-content">
                    <div class="message-line">
                        <div class="pet-name">{{item.petName}}</div>
                    </div>
                    <div class="message-line">
                        <div class="message-line__title">宠物编号：</div>
                        <div class="message-line__value">{{item.certificateNo || "-"}}</div>
                    </div>
                    <div class="message-line">
                        <div class="message-line__title">疫苗信息：</div>
                        <div class="message-line__value">{{item.vaccines || "-"}}</div>
                    </div>
                    <div class="message-line">
                        <div class="message-line__title">宠物状态：</div>
                        <div class="message-line__value" :class="item.vaccinesStatus == 1?'green':'red'">{{item.vaccinesStatus == 1?'已打疫苗':'未打疫苗'}}</div>
                    </div>
                </div>
            </div>
            <div class="no-message" v-show="list.length<=0">
                <img src="@/assets/nodata.png" class="no-image"/>
                <div class="no-title">暂无宠物</div>
            </div>
        </div>
        <div class="btn-box">
            <div class="btn btn-inner" @click="add">新增</div>
            <div class="btn" @click="back">返回</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            userData:JSON.parse(sessionStorage.getItem("TC_PET_USERDATA")),
            list:[],
            imageUrl:process.env.VUE_APP_BASE_API
        }
    },
    mounted(){
        this.getList()
    },
    methods:{
        getList(){
            let user = JSON.parse(sessionStorage.getItem("TC_PET_USERDATA"))
            let data = {
                openId : user.openId
            }
            this.$post("/pet/web/selectListByOpenId",data).then(res=>{
                let list = res.data.data || []
                // list.forEach(item=>{
                //     item.petUrlShow = this.baseUrl + item.petUrl
                //     item.rentalContractUrlShow = this.baseUrl + item.rentalContractUrl
                // })
                this.list = list
            })
        },
        goDetail(item){
            this.$router.push({path:"/petDetail",query:{showIdCard:true,pet:JSON.stringify(item)}})
        },
        add(){
            this.$router.push({path:"/petEdit"})
        },
        back(){
            this.$router.push({path:"/personCenter"})
        }
    }
}
</script>
<style scoped lang="less">
    .no-message{
        display: flex;
        flex-direction: column;
        align-items: center;
        .no-image{
            width:100px;
            margin-top:20vh;
        }
        .no-title{
            margin-top:20px;
            font-size: 15px;
            color:#000;
        }
    }
    .phone-box{
        width:100%;
        height: 100vh;
        padding:15px 15px 70px 15px;
        overflow: hidden;
        background-color: #f3f3f3;
        .message{
            height: 100%;
            overflow: auto;
            .message-item{
                display: flex;
                flex-direction: row;
                padding:10px;
                margin-bottom:15px;
                background-color: #fff;
                border-radius: 3px;
                box-shadow: 0 0 5px #00000020;
                .message-image-box{
                    flex:0 0 80px;
                    height: 80px;
                    margin-right:10px;
                    overflow: hidden;
                    border-radius: 3px;
                }
                .message-image{
                    width:100%;
                }
                .message-content{
                    flex:1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }
                .pet-name{
                    font-size: 17px;
                    color:#000;
                }
                .message-line{
                    display: flex;
                    flex-direction: row;
                }
                .message-line__title{
                    font-size: 12px;
                    color:#333;
                }
                .message-line__value{
                    font-size: 12px;
                    color:#777;
                }
            }
        }
        .btn-box{
            width:100%;
            display: flex;
            flex-direction: row;
            gap:10px;
            position: fixed;
            left:0;
            bottom:0;
            padding:0 15px;
            margin:20px 0;
            .btn{
                flex:1;
                padding:8px 25px;
                color:#317aed;
                font-size: 14px;
                border:1px solid #317aed;
                background-color: #fff;
                text-align: center;
                border-radius: 3px;
            }
            .btn-inner{
                background: #317aed;
                color:#fff;
            }
        }
    }
    .green{
        color: green !important;
    }
    .red{
        color:red!important;
    }
</style>